'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveCartLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import Price from '@/app/_components/Price';
import OrderSummary from '@/app/_components/OrderSummary';
import ExpressCheckout from '@/app/_components/ExpressCheckout';
import RecentlyViewedProducts from '@/app/_components/RecentlyViewedProducts';
import RecentlyViewedCategories from '@/app/_components/RecentlyViewedCategories';
import CartItem from './CartItem';
import SavedItem from './SavedItem';
import Spinner from '@/app/_components/Spinner';
import { useCart } from '@/app/_lib/hooks';
import { getRecentlyViewedCategories, getLastShoppingLocation } from '@/app/_lib/services/RecentlyViewedService';
import { trackViewCart, gaItemFromCartItem } from '@/app/_lib/analytics/ga4';
import ContinueShoppingLink from '@/app/_components/ContinueShoppingLink';
const Cart = () => {
  const $ = _c(72);
  const {
    cart,
    quantity: cartQuantity,
    isLoading,
    savedItems,
    refresh,
    deleteItem,
    updateItem,
    saveForLater,
    moveSavedToCart,
    deleteSavedItem
  } = useCart();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [, setRecentlyViewedCategories] = useState(t0);
  const [, setLastShoppingLocation] = useState(null);
  const hasTrackedView = useRef(false);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const categories = getRecentlyViewedCategories();
      setRecentlyViewedCategories(categories);
      setLastShoppingLocation(getLastShoppingLocation());
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== cart || $[4] !== cartQuantity || $[5] !== isLoading) {
    t3 = () => {
      if (!isLoading && !hasTrackedView.current) {
        hasTrackedView.current = true;
        const data = JSON.stringify({
          event: "CART:VIEW",
          data: {
            quantity: cartQuantity,
            sub_total: cart?.subTotal || 0
          }
        });
        navigator.sendBeacon("/api/track", new Blob([data], {
          type: "application/json"
        }));
        if (cart?.cartItems?.length) {
          trackViewCart({
            value: cart.orderTotal,
            items: cart.cartItems.map(_temp)
          });
        }
      }
    };
    $[3] = cart;
    $[4] = cartQuantity;
    $[5] = isLoading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = cart?.subTotal;
  const t5 = cart?.cartItems;
  const t6 = cart?.orderTotal;
  let t7;
  if ($[7] !== cartQuantity || $[8] !== isLoading || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = [isLoading, cartQuantity, t4, t5, t6];
    $[7] = cartQuantity;
    $[8] = isLoading;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useEffect(t3, t7);
  let t8;
  if ($[13] !== cartQuantity) {
    t8 = () => {
      if (cartQuantity === 1) {
        return `${cartQuantity} item`;
      } else {
        return `${cartQuantity} items`;
      }
    };
    $[13] = cartQuantity;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const renderCartQuantity = t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h1 className="sr-only">Shopping Cart</h1>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex items-center"><FontAwesomeIcon icon={faHiveCartLight} className="text-dark text-nav-icon align-[0px] mr-2" /><span className="text-dark text-sm font-medium">Cart</span></div>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== cart?.subTotal) {
    t11 = cart?.subTotal > 0 && <Link href="/checkout" className="text-sm text-light hover:underline border-r-1 border-gray-10 pr-2 mr-2">Checkout</Link>;
    $[17] = cart?.subTotal;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = renderCartQuantity();
  let t13;
  if ($[19] !== t12) {
    t13 = <div className="text-sm text-light border-r-1 border-gray-10 pr-2 mr-2">{t12}</div>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = cart?.subTotal || 0;
  let t15;
  if ($[21] !== t14) {
    t15 = <Price amount={t14} className="text-sm text-light" />;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t11 || $[24] !== t13 || $[25] !== t15) {
    t16 = <section className="cart-checkout-topbar-mobile">{t10}<div className="flex items-center">{t11}{t13}{t15}</div></section>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <FontAwesomeIcon icon={faHiveCartLight} className="text-4xl text-primary mr-3" />;
    t18 = <span className="text-light text-xl font-extralight mr-20">Cart</span>;
    $[27] = t17;
    $[28] = t18;
  } else {
    t17 = $[27];
    t18 = $[28];
  }
  let t19;
  if ($[29] !== cartQuantity) {
    t19 = <div className="text-sm font-medium text-primary pr-3 mr-3 border-r-1">{cartQuantity} items</div>;
    $[29] = cartQuantity;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const t20 = cart?.subTotal || 0;
  let t21;
  if ($[31] !== t20) {
    t21 = <Price amount={t20} className="text-sm font-medium" />;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t19 || $[34] !== t21) {
    t22 = <div className="cart-checkout-topbar-desktop-left"><div className="flex items-center">{t17}{t18}{t19}{t21}</div></div>;
    $[33] = t19;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="cart-checkout-topbar-desktop-right"><ContinueShoppingLink className="text-light text-xs hover:text-primary" /></div>;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t22) {
    t24 = <div className="cart-checkout-topbar-desktop-wrapper">{t22}{t23}</div>;
    $[37] = t22;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== cart || $[40] !== cartQuantity || $[41] !== deleteItem || $[42] !== isLoading || $[43] !== saveForLater || $[44] !== updateItem) {
    t25 = <section className="cart-checkout-content-area">{isLoading ? <div className="h-[350px] flex items-center justify-center"><Spinner size="lg" /></div> : cartQuantity > 0 ? <>{cart && cart.cartItems && cart.cartItems.length > 0 && cart.cartItems.map((cartItem_0, itemIndex) => <CartItem key={itemIndex} cartItem={cartItem_0} itemIndex={itemIndex} deleteCartItem={deleteItem} updateCartItem={updateItem} saveCartItemForLater={saveForLater} isTradeCustomer={cart.isTradeCustomer} promotion={cart.promotion} />)}</> : <><div className="py-16 px-6"><div className="text-center w-full"><h2 className="text-light text-2xl font-extralight mb-3 flex items-center justify-center gap-3"><FontAwesomeIcon icon={faHiveCartLight} className="text-3xl text-light" /><span>Your cart is empty</span></h2><p className="text-light text-sm mb-6 max-w-md mx-auto">Discover our curated collection of modern furniture, lighting, and accessories from the world's best designers.</p><ContinueShoppingLink className="inline-flex items-center gap-2 text-primary text-sm hover:underline"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-sm" /> Continue Shopping</ContinueShoppingLink></div></div></>}</section>;
    $[39] = cart;
    $[40] = cartQuantity;
    $[41] = deleteItem;
    $[42] = isLoading;
    $[43] = saveForLater;
    $[44] = updateItem;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== cart || $[47] !== refresh) {
    t26 = <div className="order-1 mb-4"><OrderSummary cart={cart} displayCheckoutButton={true} showPromoCode={true} onPromotionChange={refresh} /></div>;
    $[46] = cart;
    $[47] = refresh;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== cart) {
    t27 = cart && cart.subTotal > 0 && <ExpressCheckout expressCheckoutData={cart.expressCheckoutData} />;
    $[49] = cart;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== t27) {
    t28 = <div className="order-2">{t27}</div>;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t26 || $[54] !== t28) {
    t29 = <section className="cart-checkout-sidebar"><div className="cart-checkout-sidebar-inner flex flex-col">{t26}{t28}</div></section>;
    $[53] = t26;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t25 || $[57] !== t29) {
    t30 = <div className="cart-checkout-grid">{t25}{t29}</div>;
    $[56] = t25;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== deleteSavedItem || $[60] !== moveSavedToCart || $[61] !== savedItems) {
    t31 = savedItems && savedItems.length > 0 && <section className="w-full my-8 order-3"><div className="mb-8"><h3 className="leading-[1] text-2xl font-extralight">Your Saved Items</h3><p className="text-xs text-light-3 m-0">Items you've saved for later</p></div><div>{savedItems.map((savedItem, itemIndex_0) => <SavedItem key={itemIndex_0} savedItem={savedItem} itemIndex={itemIndex_0} moveSavedItemToCart={moveSavedToCart} deleteSavedItem={deleteSavedItem} />)}</div></section>;
    $[59] = deleteSavedItem;
    $[60] = moveSavedToCart;
    $[61] = savedItems;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t24 || $[64] !== t30 || $[65] !== t31) {
    t32 = <div className="site-padding">{t24}{t30}{t31}</div>;
    $[63] = t24;
    $[64] = t30;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  let t34;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <RecentlyViewedProducts title="Recently Viewed Products" />;
    t34 = <RecentlyViewedCategories />;
    $[67] = t33;
    $[68] = t34;
  } else {
    t33 = $[67];
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t16 || $[70] !== t32) {
    t35 = <>{t9}{t16}{t32}{t33}{t34}</>;
    $[69] = t16;
    $[70] = t32;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  return t35;
};
export default Cart;
function _temp(cartItem, index) {
  return gaItemFromCartItem(cartItem, index);
}